/* C */
export const CONDO_INSERT = 'CONDO_INSERT';
export const CONDO_INSERT_FAIL = 'CONDO_INSERT_FAIL';
export const CONDO_INSERT_SUCCESS = 'CONDO_INSERT_SUCCESS';
export const CONDO_SEARCH = 'CONDO_SEARCH';
export const CONDO_SEARCH_FAIL = 'CONDO_SEARCH_FAIL';
export const CONDO_SEARCH_SUCCESS = 'CONDO_SEARCH_SUCCESS';
export const CONDO_SELECT = 'CONDO_SELECT';
export const CONDO_SELECT_FAIL = 'CONDO_SELECT_FAIL';
export const CONDO_SELECT_SUCCESS = 'CONDO_SELECT_SUCCESS';
export const CONDO_UPDATE = 'CONDO_UPDATE';
export const CONDO_UPDATE_FAIL = 'CONDO_UPDATE_FAIL';
export const CONDO_UPDATE_SUCCESS = 'CONDO_UPDATE_SUCCESS';
